var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedemption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M61.3334 37.0732V45.3096C61.3334 49.6161 57.8271 53.1224 53.5206 53.1224H42.931C38.6245 53.1224 35.1182 49.6161 35.1182 45.3096V37.0732C35.1182 34.014 37.6126 31.5195 40.6718 31.5195H55.7562C58.8154 31.5195 61.3099 34.014 61.3099 37.0732H61.3334Z",
    fill: "#EA0404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1414 28.2722H53.7559C55.0031 28.2722 56.015 27.2603 56.015 26.0131V21.8949C56.015 20.6476 55.0031 19.6357 53.7559 19.6357H4.92587C3.67865 19.6357 2.66675 20.6476 2.66675 21.8949V26.0131C2.66675 27.2603 3.67865 28.2722 4.92587 28.2722H33.1414Z",
    stroke: "#EA0404",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4124 19.6596C41.0954 18.4359 44.1782 16.671 45.5666 14.4354C46.555 12.8352 46.6491 10.9761 45.896 9.06998C45.3548 7.75216 44.6017 6.76379 43.6134 6.12841C42.6485 5.51657 41.5661 5.2577 40.3188 5.35183C37.942 5.56363 35.2829 7.16384 32.9767 9.77596C31.4941 11.4703 30.2469 13.447 29.3527 15.565C28.4584 13.447 27.2112 11.4703 25.7286 9.77596C23.4225 7.16384 20.7397 5.56363 18.3865 5.35183C17.1628 5.2577 16.0568 5.51657 15.0919 6.12841C14.1036 6.76379 13.327 7.75216 12.8093 9.06998C12.0327 10.9761 12.1504 12.8352 13.1152 14.4354C14.5036 16.671 17.5629 18.4359 22.2694 19.6596H36.436H36.4124ZM23.1401 17.3064C18.9983 16.2474 16.2686 14.8119 15.2331 13.1176C14.6683 12.1763 14.6213 11.1879 15.0919 10.0113C15.6802 8.55226 16.5745 7.84629 17.8217 7.84629C17.9158 7.84629 18.01 7.84629 18.1276 7.84629C19.822 7.98748 21.9634 9.32884 23.8225 11.4232C25.5169 13.3294 26.8347 15.6826 27.6348 18.1771C26.4582 18.0123 24.8344 17.73 23.1165 17.3064H23.1401ZM31.0235 18.1771C31.8236 15.7062 33.1414 13.3529 34.8357 11.4232C36.6948 9.32884 38.8127 7.98748 40.5306 7.84629C40.6248 7.84629 40.7424 7.84629 40.8365 7.84629C42.0838 7.84629 42.978 8.55226 43.5663 10.0113C44.037 11.2114 44.0134 12.1998 43.4251 13.1176C42.3897 14.8119 39.6599 16.2474 35.5182 17.3064C33.8003 17.73 32.1766 18.0123 30.9999 18.1771H31.0235Z",
    fill: "#EA0404"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5169 56.3704H10.2442C8.99701 56.3704 7.98511 55.3585 7.98511 54.1113V28.249H50.6967V54.1113C50.6967 55.3585 49.6848 56.3704 48.4376 56.3704H25.5169Z",
    stroke: "#EA0404",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3291 18.1768V56.3701",
    stroke: "#EA0404",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemption);
export default __webpack_public_path__ + "static/media/Redemption.975f478ba199f355ff1237d9b014e1f0.svg";
export { ForwardRef as ReactComponent };